import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatInputModule} from "@angular/material/input";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {AlterarCampanhaFormDto} from "../alterarCampanhaForm.dto";
import {ToastrService} from "ngx-toastr";


@Component({
  selector: 'app-modal-edicao-camapanha',
  templateUrl: './modal-edicao-campanha.component.html',
  styleUrls: ['./modal-edicao-campanha.component.sass'],
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatFormFieldModule, MatDatepickerModule, MatInputModule, ReactiveFormsModule],
})
export class ModalEdicaoCampanhaComponent implements OnInit {
  form: FormGroup;

  constructor(
      private formBuilder: FormBuilder,
      private toasterService: ToastrService,
      public dialogRef: MatDialogRef<ModalEdicaoCampanhaComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      id: this.data.campanha.id,
      ano: this.data.campanha.ano,
      dataInicio: ['', Validators.required],
      dataFim: ['', Validators.required]
    });
    this.fillFormWithData();

  }
  private fillFormWithData(): void {
    // Converte a string de data em um objeto Date
    const dataInicio = this.parseDate(this.data.campanha.dataInicio);
    const dataFim = this.parseDate(this.data.campanha.dataFim);


    // Preencha os campos do formulário com os dados fornecidos
    this.form.patchValue({
      dataInicio: dataInicio,
      dataFim: dataFim,

      // Preencha outros campos conforme necessário
    });
  }

  private parseDate(dateString: string): Date {
    const parts = dateString.split('/');
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);
    return new Date(year, month, day);
  }

  realizarAcao() {
    let obj: AlterarCampanhaFormDto;
    obj = this.form.getRawValue();
    if(obj.dataFim > obj.dataInicio){
      if(this.form.valid){
        this.data.action(obj)
        this.dialogRef.close();
      }
    } else {
      this.toasterService.error("Data Fim menor que data Inicio")
    }

  }
}
